// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2gBJ0","actionsCol":"EnrolledClinics_actionsCol__Bk4fo"};